// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f87bd146","498":"e3db00c2"}[chunkId] + ".chunk.js";
};